<template lang="pug">
  .final-report-upload(v-loading="loading")
    campaign-info
    title-bar
      span {{ $t('结案信息') }}
      el-button(
        v-if="isView"
        type="text"
        @click="quotationVisible = true"
      ) {{ $t('查看报价') }}

    div(style="margin-left: 20px")
      el-row
        el-col(:span="4") {{ $t('结案信息') }}
        el-col(
          v-if="isView"
          :span="20"
        )
          a(
            target="_blank"
            :href="log.download_url"
          ) {{ log.file_name_list.length !== 0 ? log.file_name_list : log.file_name }}
        el-col(
          v-else
          :span="20"
        ) —
      el-row
        el-col(:span="4") {{ $t('完成情况') }}
        el-col(
          v-if="isView"
          :span="20"
        )
          kpi-situation(
            v-model="kpi"
            :viewData="kpi"
            :isEdit="false"
          )
        el-col(
          v-else
          :span="20"
        ) —
    template(v-if="quotationVisible")
      title-bar
        span {{ $t('报价') }}
      div(style="margin-left: 20px")
        el-row(style="margin:30px 0")
          el-col(:span="20" :offset="4")
            el-button(@click="handleViewQuotation") {{ $t('查看报价') }}
        el-row(style="margin:30px 0")
          el-col(:span="19" :offset="4")
            quotation-overview(:data="quotation.price_overview")

    quotation-dialog(
      v-if="newQuotation.length !== 0"
      :visible="editDialogVisible"
      :data="newQuotation"
      :hasFilled="true"
      :viewMode="isView || !quotationEdit"
      @close="onClose"
    )

    //- el-row(style="margin-left: 20px")
    //-   el-col(
    //-     :span="20"
    //-     :offset="4"
    //-   )
    //-     footer-button(
    //-       v-if="!isView"
    //-       @confirm="onConfirm"
    //-       @cancel="$router.push('/vendor-campaign/process')"
    //-     )
</template>

<script>
import axios from 'axios'
import TitleBar from '@/components/TitleBar'
import SubFinalScope from '@/components/SubFinalScope'
import QuotationOverview from '@/components/QuotationOverview'
import { default as Dialog } from '@/components/QuotationList/QuotationDialog'
import KpiSituation from '@/components/KpiSituation'
import QuotationDialog, { normalizeQuotation } from '@/components/QuotationDialog'
import CampaignInfo from '../FinalReportUpload/CampaignInfo'

const getCompletedProgress = subFinalScopeId => {
  return axios.get('/management/subfinal/getCompletedProgress', {
    params: {
      sub_final_scope_id: subFinalScopeId
    }
  })
}

export default {
  components: {
    TitleBar,
    SubFinalScope,
    KpiSituation,
    QuotationOverview,
    Dialog,
    QuotationDialog,
    CampaignInfo
  },
  data () {
    return {
      kpi: [],
      quotationVisible: false,
      quotationEdit: false,
      quotation: {},
      dialogVisible: false,
      editDialogVisible: false,
      newQuotation: [],
      log: {
        file_name_list: []
      },
      loading: false,
      quotationParams: null,
      subFinalScope: {}
    }
  },
  computed: {
    campaignId () {
      return this.$store.state.campaign.id
    },
    uploadParams () {
      return {
        campaign_id: this.campaignId,
        file_type: 6
      }
    },
    campaign () {
      return this.$store.state.campaign
    },
    auditVersionId () {
      switch (this.campaign.businessType) {
        case 1:
        case 5:
          return this.campaignId()
        case 2:
        case 6:
          return this.campaign.subFinalScopeId
        case 4:
        case 8:
          return this.campaign.subFinalScopeVendorId
      }
    },
    activePhaseType () {
      return this.$store.state.campaign.activePhaseType
    },
    phaseType () {
      return this.$store.state.campaign.phaseType
    },
    businessType () {
      return this.$store.state.campaign.businessType
    },
    subFinalScopeId () {
      return this.$store.state.campaign.subFinalScopeId
    }
  },
  mounted () {
    this.fetchData()
  },
  methods: {
    async fetchData () {
      try {
        this.subFinalScope = await getCompletedProgress(this.subFinalScopeId)
        this.fetchLog()
        this.fetchQuotation()
        this.fetchQuotationDetail()
      } catch (err) {
        throw new Error(err)
      }
    },
    fetchLog () {
      this.loading = true
      axios.get('/common/getBusinessLog', {
        params: {
          servlet_path: this.$route.path,
          business_key: this.subFinalScope.sub_final_scope_vendor.sub_final_scope_vendor_id
        }
      })
        .then(res => {
          this.log = res
          this.loading = false
        })
    },
    fetchQuotation () {
      this.loading = true
      axios.get('/management/subfinal/getVendorPriceOverview', {
        params: { sub_final_scope_vendor_id: this.subFinalScope.sub_final_scope_vendor.sub_final_scope_vendor_id }
      })
        .then(res => {
          this.quotation = res
          this.loading = false
        })
    },
    fetchQuotationDetail () {
      this.loading = true
      axios.get('/management/subfinal/getVendorQuotation', {
        params: {
          sub_final_scope_vendor_id: this.subFinalScope.sub_final_scope_vendor.sub_final_scope_vendor_id,
          phase_current: this.activePhaseType,
          phase_reality: this.phaseType
        }
      })
        .then(res => {
          if (this.$store.state.campaign.taskId == null) {
            this.$store.commit('campaign/setTaskId', res.task_id)
          }
          this.newQuotation = res.vendor_price.map(item => normalizeQuotation(item))
          this.loading = false
        })
    },
    handleViewQuotation () {
      this.editDialogVisible = true
    },
    onClose (res, params) {
      this.editDialogVisible = false
    }
  }
}
</script>

<style lang="stylus" scoped>
.title-bar
  display flex
  justify-content space-between

.final-report-upload__sync
  color $main
  cursor pointer
  > i
    margin-right 10px
</style>
